/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DoordashOnboardingValidationResponse } from '../../models/doordash-onboarding-validation-response';

export interface DoordashStoresStoreIdOnboardingValidationGet$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
}

export function doordashStoresStoreIdOnboardingValidationGet(http: HttpClient, rootUrl: string, params: DoordashStoresStoreIdOnboardingValidationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DoordashOnboardingValidationResponse>> {
  const rb = new RequestBuilder(rootUrl, doordashStoresStoreIdOnboardingValidationGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DoordashOnboardingValidationResponse>;
    })
  );
}

doordashStoresStoreIdOnboardingValidationGet.PATH = '/doordash/stores/{storeId}/onboarding/validation';
